import { useEffect } from "react";
import { canonicalPortalRedirect } from "./canonicalPortal";

/**
 * Sends the visitor to the org's current portal subdomain when they arrived on
 * one it was renamed away from, keeping the path and query intact.
 *
 * Safe to call on both the signed-out login screen and the signed-in shell: the
 * target is computed from the live hostname, so once the redirect has happened
 * the condition is false and it cannot loop.
 */
export function useCanonicalPortalRedirect(
  canonicalSubdomain: string | undefined,
) {
  useEffect(() => {
    if (!import.meta.env.PROD) return;

    const target = canonicalPortalRedirect(
      window.location.hostname,
      canonicalSubdomain,
      window.location.pathname,
      window.location.search,
    );

    if (target) window.location.replace(target);
  }, [canonicalSubdomain]);
}
